// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IHP_D","graphics":"styles_graphics__G0Bsp"};